import moment from 'moment';

export const extractPlainDate = (date: Date | string): string => moment.parseZone(date).format('YYYY-MM-DD');

export const sanitizeString = (value: string | undefined | null): string | undefined =>
  // Remove ASCII control chars
  // Remove Extended ASCII control
  // Remove Unicode invisible chars
  // Keep Unicode visible chars (accents, emojis, etc.)
  // Keep Line breaks (\n, \r, \t)
  (value = value?.replace(/[\x00-\x1F\x7F\u0080-\u009F\u200B-\u200F\u2028\u2029\u2060\uFEFF]/g, ''));

export const xmlDataSanitizer = (value: string): string => {
  const sanitized = sanitizeString(value) ?? '';

  return (
    sanitized
      // Remove XML non-characters
      .replace(/[\uFDD0-\uFDEF\uFFFE\uFFFF]/g, '')
      // Remove broken surrogate pairs
      .replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g, '')
      // Replace disallowed CDATA terminator
      .replace(/]]>/g, ']]]]><![CDATA[>')
      // Remove other non-printable characters (Unicode range above BMP can also be problematic)
      .replace(/[^\u0009\u000A\u000D\u0020-\uD7FF\uE000-\uFFFD]/g, '')
  );
};
